import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  ListGroup,
  Button,
  Modal,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import SupervisorSearchBar from "../SupervisorSearchBar/SupervisorSearchBar";
import { updateCandidateData } from "../../Slices/orgAdminSlice";
import { useDispatch } from "react-redux";
import { showModal, showSpinner } from "../../Slices/sessionSlice";
import { newAlert } from "../../Slices/alertSlice";
import SpinnerButton from "../SpinnerButton/SpinnerButton";
export const id = "SUPERVISOR_EDIT";
const saveCandidateId = "supervisorEdit.save";

function SupervisorsEditModal({ data }) {
  let { position, candidateId } = data;

  const [supervisors, setSupervisors] = useState(data.supervisors || []);
  const [positionName, setPositionName] = useState(position);
  const dispatch = useDispatch();

  const changePosition = (e) => {
    setPositionName(e.target.value);
  };
  const saveCandidateData = () => {
    const payload = {};
    payload.supervisors = supervisors;
    payload.newPosition = positionName;
    payload.candidateId = data.candidateId;
    dispatch(showSpinner({ id: saveCandidateId }));
    dispatch(updateCandidateData(payload));
  };

  const addSupervisor = (supervisorToBeAdded) => {
    console.log(supervisorToBeAdded, "supervisors");
    let isValidSupervisor = true;
    supervisors.forEach((supervisor) => {
      if (supervisor._id === supervisorToBeAdded._id) {
        isValidSupervisor = false;
      }
    });
    if (isValidSupervisor) {
      setSupervisors([...supervisors, supervisorToBeAdded]);
    }
  };
  return (
    <Modal
      show={true}
      centered
      onHide={() => {
        dispatch(showModal(null));
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <InputGroup className="mb-3">
            <InputGroup.Text id="edit-position">Position</InputGroup.Text>
            <FormControl
              id="basic-url"
              aria-describedby="basic-addon3"
              onChange={(e) => changePosition(e)}
              placeholder={positionName}
            />
          </InputGroup>
          <Card>
            <Card.Body>
              <Card.Title>List of supervisors</Card.Title>
              <ListGroup>
                {supervisors &&
                  supervisors.map((item) => (
                    <ListGroup.Item key={String(Math.random())}>
                      <Container>
                        <Row xs="">
                          <Col xs={10}>
                            {item.firstName} {item.lastName}
                          </Col>
                          <Col xs={2}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="red"
                              className="bi bi-trash"
                              viewBox="0 0 16 16"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSupervisors(
                                  supervisors.filter(
                                    (supervisor) => item._id !== supervisor._id
                                  )
                                );
                              }}
                            >
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                              <path
                                fillRule="evenodd"
                                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                              />
                            </svg>
                          </Col>
                        </Row>
                      </Container>
                    </ListGroup.Item>
                  ))}
              </ListGroup>
            </Card.Body>
            <Card.Footer>
              <Container>
                <Row>
                  <Col>
                    <SupervisorSearchBar
                      defaultSelected={null}
                      handleSelection={addSupervisor}
                    />
                  </Col>
                </Row>
              </Container>
            </Card.Footer>
          </Card>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-danger"
          onClick={() => {
            dispatch(showModal(null));
          }}
        >
          Cancel
        </Button>
        <SpinnerButton
          variant="outline-primary"
          id={saveCandidateId}
          onClick={saveCandidateData}
          name="Save"
        />
      </Modal.Footer>
    </Modal>
  );
}

export default SupervisorsEditModal;
